// extracted by mini-css-extract-plugin
export default {"block":"solutions_block__4v0kb","item":"solutions_item__lo8vR","checked":"solutions_checked__ByXW2","actions":"solutions_actions__M-AtY"};